import { useNavigate } from "react-router-dom";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton, BCPageRedirect } from "../../shared/styled/global.styled";

const ErrorServer = () => {
  const navigate = useNavigate();
  return (
    <LayoutMain idPage="errorServer" titlePage={false}>
      <BCPageRedirect>
        <h1>Error del servidor</h1>
        <p>
          Tenemos un error de conexión con el servidor intenta, vuelve a intentar más tarde.
        </p>
        <BCButton
          type="button"
          className="bc-button-primary bc-button-small"
          onClick={() => navigate("/")}
        >
          Ir al inicio
        </BCButton>
      </BCPageRedirect>
    </LayoutMain>
    
  );
};

export default ErrorServer;
